import { Box, Button, Dialog, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { useStyles } from '../../styles';

interface FeatureDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  body?: string[];
}

export const FeatureDialog = ({
  open,
  onClose,
  title,
  body = []
}: FeatureDialogProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      maxWidth="sm">
      <Box className={classes.dialogHeader}>
        {title && (
          <Typography className={classes.dialogTitle}>{title}</Typography>
        )}
        <IconButton
          size="small"
          onClick={onClose}
          className={classes.dialogCloseIcon}
          aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box className={classes.dialogBody}>
        {body.map(paragraph => (
          <Typography key={paragraph} variant="body2">
            {paragraph}
          </Typography>
        ))}
      </Box>
      <Box className={classes.dialogActions}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          size="small"
          disableElevation
          style={{
            borderRadius: 99,
            textTransform: 'none',
            padding: '4px 16px'
          }}>
          Got it
        </Button>
      </Box>
    </Dialog>
  );
};

export default FeatureDialog;
